import { useContext, useRef, useState } from 'react'
import { useEffect, useLayoutEffect } from 'react'

import ExclamationDot from 'src/assets/exclamation_dot.png'
import ExclamationStick from 'src/assets/exclamation_stick.png'
import ReloadIcon from 'src/assets/reload-icon.png'
import BuildContext from 'src/context/buildContext'

const ReloadBuildBanner = () => {
    const { SHOW_RELOAD_BANNER } = useContext(BuildContext)

    const TimerRef = useRef(null)
    const [seconds, setSeconds] = useState(60)

    useLayoutEffect(() => {
        if (!SHOW_RELOAD_BANNER) return () => clearInterval(TimerRef?.current)

        TimerRef.current = setInterval(() => {
            setSeconds((prev) => prev - 1)
        }, 1000)

        return () => clearInterval(TimerRef?.current)
    }, [SHOW_RELOAD_BANNER])

    useEffect(() => {
        if (seconds <= 0 && SHOW_RELOAD_BANNER) {
            clearInterval(TimerRef?.current)
            TimerRef.current = setTimeout(() => {
                window.location.reload(true)
            }, 2 * 1000)
        }
    }, [SHOW_RELOAD_BANNER, seconds])

    useEffect(() => {
        return () => clearTimeout(TimerRef?.current)
    }, [])

    return (
        <>
            {SHOW_RELOAD_BANNER ? (
                <div className="relative z-10 flex w-full items-center justify-between bg-primary-red p-3 text-13-15 font-bold">
                    <div className="flex items-center gap-6 pl-2">
                        <div>
                            <img
                                src={ExclamationStick}
                                style={{ marginBottom: '2px' }}
                                alt="Exclamation"
                            />
                            <img src={ExclamationDot} alt="Exclamation" />
                        </div>
                        {seconds > 0 ? (
                            <div>
                                A new build was released, please reload the page
                                or a reload will be performed for you
                                within&nbsp;
                                {/* <Countdown
                                eventTimeEpoch={secondsLeft}
                                interval={1000}
                            /> */}
                                {seconds}&nbsp;seconds.
                            </div>
                        ) : (
                            <>Reloading....</>
                        )}
                    </div>
                    <div
                        className="relative -left-0.5 -top-0.5 cursor-pointer"
                        onClick={() => {
                            window.location.reload(true)
                        }}
                    >
                        <img
                            src={ReloadIcon}
                            alt="Reload"
                            height="20px"
                            width="20px"
                            style={{
                                filter: 'brightness(0) saturate(100%) invert(92%) sepia(100%) saturate(0%) hue-rotate(202deg) brightness(106%) contrast(106%)',
                            }}
                        />
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default ReloadBuildBanner
